import red from '@material-ui/core/colors/red';
import { createMuiTheme } from '@material-ui/core/styles';
import fondo from './images/payway-fondo.png';

// A custom theme for this app
const theme = createMuiTheme({
  overrides : {
    MuiCssBaseline: {
      '@global': {
        body: {
          background: `url(${fondo}) no-repeat fixed`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        },
      },
    },
    MuiStepIcon: {
      root : {
        color: 'white',
        border: '2px solid',
        borderRadius: '50%',
        borderColor: '#9d9d9d',
        fontSize: '2.6rem',
      },
      text: {
        fill: '#9d9d9d',
        fontSize: '0.9rem',
        fontWeight: 400
      },
      active : {
        color: '#f9b655 !important',
        border: 'none',
        '& text' : {
          fill: 'white',
          fontWeight: 400
        }
      },
      completed : {
        color: '#9d9d9d !important',
        border: 'none',
        fontSize: '2.6rem !important',
        borderRadius: '50%',
      }
    },
    MuiStepLabel: {
      root : {
        padding: '2rem 0',
      },
      label: {
        fontSize: '1.3rem !important',
      },
      active: {
        color: 'rgb(30, 67, 132) !important',
        fontSize: '1.3rem'
      },
      completed: {
        color: '#9d9d9d !important',
        fontSize: '1.3rem !important'
      }
    }
  },
  palette: {
    primary: {
      main: '#023F86',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#eee',
    },
  },
});

export default theme;